/** In-memory pending clips between capture → upload (Blobs don't survive refresh). */
const pending = new Map();

export function stashClips(sessionId, clips) {
  if (!sessionId) return;
  pending.set(sessionId, clips);
}

export function takeClips(sessionId) {
  const clips = pending.get(sessionId) || null;
  pending.delete(sessionId);
  return clips;
}

export function peekClips(sessionId) {
  return pending.get(sessionId) || null;
}

/** Normalize stash shape: process items are { sequence, blob }. */
export function normalizeStashedClips(clips) {
  if (!clips) return null;
  const process = Array.isArray(clips.process)
    ? clips.process
        .map((item, index) => {
          if (!item) return null;
          if (item instanceof Blob) return { sequence: index, blob: item };
          if (item.blob instanceof Blob) {
            return { sequence: Number(item.sequence) || index, blob: item.blob };
          }
          return null;
        })
        .filter(Boolean)
        .sort((a, b) => a.sequence - b.sequence)
    : [];
  return {
    before: clips.before instanceof Blob ? clips.before : null,
    process,
    result: clips.result instanceof Blob ? clips.result : null,
  };
}

export function hasFullLocalSet(clips, minProcess = 1) {
  const n = normalizeStashedClips(clips);
  return Boolean(n?.before && n?.result && n.process.length >= minProcess);
}
